<div class="sidebar-overlay" *ngIf="!collapsed()" (click)="toggleCollapse()"></div>

<aside class="sidebar" [class.collapsed]="collapsed()">
  
  <!-- Logo Area -->
  <div class="sidebar__logo" (click)="toggleCollapse()">
    <!-- Ícone compacto (sidebar colapsada) -->
    <div class="sidebar__logo-compact" [class.hidden]="!collapsed()">
      <img src="assets/logo-compact.png" alt="Madero Inventário" class="sidebar__logo-icon-img" />
    </div>

    <!-- Logo completo (sidebar expandida) -->
    <div class="sidebar__logo-full" [class.visible]="!collapsed()">
      <img src="assets/logo-expanded.png" alt="Madero Inventário" class="sidebar__logo-full-img" />
    </div>
  </div>

  <!-- Navigation Menu -->
  <nav class="sidebar__nav">
    <span class="sidebar__section-title" *ngIf="!collapsed()">GERENCIAMENTO</span>
    
    <a *ngFor="let item of visibleMenuItems"
       class="sidebar__item"
       [routerLink]="item.route"
       routerLinkActive="sidebar__item--active"
       [routerLinkActiveOptions]="{exact: item.route === '/home'}"
       [title]="item.label">
      <span class="material-symbols-rounded sidebar__item-icon">{{ item.icon }}</span>
      <span class="sidebar__item-label" *ngIf="!collapsed()">{{ item.label }}</span>
      
      <!-- Tooltip para quando estiver colapsado -->
      <div class="sidebar__tooltip" *ngIf="collapsed()">
        {{ item.label }}
      </div>
    </a>
  </nav>

  <!-- Footer User & Logout -->
  <div class="sidebar__footer">
    <div class="sidebar__user">
      <div class="sidebar__avatar">{{ authService.currentUser()?.name?.slice(0, 2)?.toUpperCase() || 'US' }}</div>
      <div class="sidebar__user-info" *ngIf="!collapsed()">
        <span class="sidebar__user-name">{{ authService.currentUser()?.name }}</span>
      </div>
    </div>

    <!-- Theme Toggle Button -->
    <button
      class="sidebar__theme-btn"
      (click)="themeService.toggle()"
      [title]="themeService.isDark() ? 'Mudar para Modo Claro' : 'Mudar para Modo Escuro'">
      <span class="material-symbols-rounded">
        {{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}
      </span>
      <span class="sidebar__theme-label" *ngIf="!collapsed()">
        {{ themeService.isDark() ? 'Modo Claro' : 'Modo Escuro' }}
      </span>
    </button>

    <button class="sidebar__logout-btn" (click)="logout()">
      <span class="material-symbols-rounded">logout</span>
      <span *ngIf="!collapsed()">Sair do Sistema</span>
    </button>
  </div>

  <!-- Botão circular flutuante de colapso -->
  <button (click)="toggleCollapse()" class="sidebar__toggle">
    <span class="material-symbols-rounded">
      {{ collapsed() ? 'chevron_right' : 'chevron_left' }}
    </span>
  </button>

</aside>
